<script lang="ts">
import { defineComponent } from "vue";
import { mapState, mapActions } from "pinia";
import AppBarComponent from "~/components/AppBarComponent.vue";
import { useErrorMessageStored } from "~/store/errorMessageStored";
import { useSuccessMessageStored } from "~/store/successMessageStored";
import { useAuthStored } from "~/store/authStored";

export default defineComponent({
  components: { AppBarComponent },
  computed: {
    ...mapState(useErrorMessageStored, [
      "messaggio",
      "titolo",
      "visibleErrorMessage"
    ]),
    ...mapState(useSuccessMessageStored, [
      "messaggioSuccess",
      "titoloSuccess",
      "visibleSuccessMessage",
      "messageType"
    ])
  },
  methods: {
    ...mapActions(useErrorMessageStored, ["clearError"]),
    ...mapActions(useSuccessMessageStored, ["clearSuccess"])
  }
});
</script>

<template>
  <v-layout class="rounded rounded-md">
    <AppBarComponent />

    <!--    <DrawerComponent :drawer="drawer" />-->

    <v-main style="min-height: 300px">
      <div class="ma-5">
        <ErrorMessage
          v-if="visibleErrorMessage"
          :text="messaggio"
          :titolo="titolo"
          @clearError="clearError"
        />

        <SuccessMessage
          v-if="visibleSuccessMessage"
          :text="messaggioSuccess"
          :titolo="titoloSuccess"
          :type="messageType"
          @clearMessage="clearSuccess"
        />

        <slot />
      </div>
    </v-main>

    <v-footer app class="d-flex align-center justify-center">
      <div>
        {{ new Date().getFullYear() }} — <strong>Dondi Salotti SRL</strong>
      </div>
    </v-footer>
  </v-layout>
</template>
